<template>

<v-card v-if="club" @click="select(club)" v-bind="$attrs" min-height="50" >
       <v-hover
                                v-slot="{ hover }"
                              >
              <v-img v-if="banner"
              :src="banner" 
                class="white--text py-3 text-left pb-3"
                :gradients="hover? getGradient(color) : getGradient('#000000')"
               height="130"
              >
               <v-btn class="float-right mr-3" depressed fab small :color="dark? null : 'primary'" @click="toggleFavorite">
                            <v-icon v-if="favorite">favorite</v-icon>
                            <v-icon v-else>favorite_border</v-icon>
                          </v-btn>
            
              
                <slot></slot>
            </v-img>
       </v-hover>
      <v-avatar class="mt-2 mr-2 float-left" v-if="club.logo">
            <v-img :src="club.logo"></v-img>
          </v-avatar>
            <v-card-title class="font-weight-bold text-h6 ma-0">
                 
                  {{club.name}}
                   

                  <v-spacer></v-spacer>
            </v-card-title>
            <v-card-subtitle v-if="!club.status">Nog niet actief</v-card-subtitle>
            <v-card-subtitle v-else-if="club._hub" v-html="club._hub.name" class="pt-0 pl-2"></v-card-subtitle>
          <v-card-text v-if="club.description" v-html="description" @click.stop="viewMore=!viewMore"></v-card-text>
            <v-card-actions>
                  <external-link v-if="club._address" v-model="club._address.name" icon="store" location class="caption"></external-link>
                  <v-spacer></v-spacer>   
                  <external-link v-model="club.website" icon="public" class="caption"></external-link>
        </v-card-actions>
  </v-card>
                                            
</template>
<script>
import cardItem from '@/modules/cardItem'
import externalLink from '@/components/externalLink'

export default {
  mixins: [cardItem],
  components:{externalLink},
   props: {
    value: {
      type: Object,
      default: function () {
        return null
      },
    },
      dark:{
        type: Boolean,
        default: function () {
          return false
        },
      }
   },
  data: () => ({
     viewMore:false
  }),
  computed: {
    favorite:{
      get(){
        return this.club._favorite
      },
      set(value){
        this.club._favorite = value
      }
    },
    banner(){
      //return '/bg-card.png'
      return this.club.banner
    },
    color(){
      if (this.club.color && this.club.color.includes('#')) return this.club.color 
      if (!this.club.type || !this.club.type[0]) return '#000000'
      return this._config('menu',this.club.type[0]).color || '#000000'
    },
    club: {
        get: function() {
          return this.value;
        },
        set: function(value) {
          this.$emit('input', value)
        }
    },
    user(){
      return this.$store.state.user
    },
    website(){
      if (!this.club.website) return null
      if (this.club.website.includes(':')) return this.club.website
      return 'http://' + this.club.website
    },
    description(){
      if (!this.club.description) return null
      if (!this.viewMore) {
        let d = this.club.description.slice(0, 200)
        if (d.length==200) d += ' <b>...</b>'
        return d
      }
      return this.club.description.replace(/(?:\r\n|\r|\n)/g, '<br>')
    }
  },
  mounted () {
   
  },
watch: {

},
methods: {
   select(club){
     this.$emit('select', club)
    //this.setHost(club)
    //this.$router.push({'path' : "/" + club._id})
  },
  goto(club){
    this.$router.push({'path' : "/" + club._id})
  },
  async toggleFavorite() {
      this.favorite = !this.favorite;
      if (this.favorite) {
        let response = await this.$http.post(
          "/api/edge/CONSUMERS/" + this.club._id,
          { _id: this.user._id, favorite: true, date: new Date() }
        );
      } else {
        let response = await this.$http.delete(
          "/api/edge/CONSUMERS/" + this.club._id,
          { _id: this.user._id }
        );
      }
    },
    },
}

</script>
